export default __webpack_public_path__ + "static/media/gov-mg-brand-original-pattern.0414273d.png";